import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap } from 'lucide-react';

const LotCard = ({ lot }) => {
  const navigate = useNavigate();

  return (
    <div 
      className={`p-4 rounded-lg shadow-md cursor-pointer hover:shadow-lg transition-shadow border ${
        lot.status === 'lightning'
          ? 'bg-amber-50 dark:bg-amber-900/30 border-amber-200 dark:border-amber-700'
          : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700'
      }`}
      onClick={() => navigate(`/lots/${lot.id}`)}
    >
      <div className="flex justify-between items-start">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <span className="text-3xl font-bold text-gray-800 dark:text-white">{lot.display_id || lot.id}</span>
            {(lot.needs_reconciliation || lot.status === 'lightning') && (
              <Zap className={`w-6 h-6 ${
                lot.status === 'lightning' ? 'text-amber-500' : 'text-yellow-500'
              }`} />
            )}
          </div>
          <div className="text-xl font-medium text-gray-700 dark:text-gray-200">{lot.title}</div>
          {lot.supplier && (
            <div className="text-gray-600 dark:text-gray-400 text-sm">{lot.supplier}</div>
          )}
          {lot.status === 'lightning' && (
            <div className="text-amber-600 dark:text-amber-400 text-sm font-medium">
              Lote relámpago
            </div>
          )}
        </div>
        <div className="text-right">
          <div className={`text-2xl font-bold ${
            lot.quantity > 0
              ? 'text-green-600 dark:text-green-400'
              : lot.quantity === 0
                ? 'text-amber-600 dark:text-amber-400'
                : 'text-red-600 dark:text-red-400'
          }`}>
            {lot.quantity} {lot.unit}
          </div>
          <div className="text-sm text-gray-500 dark:text-gray-400">
            {new Date(lot.timestamp).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit'
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LotCard; 